import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

const SubMenuItem = ({ children, inverse, title }) => {
  const classes = cns(
    'dropdown__listItem subMenu',
    {
      inverse,
    },
  );

  return (
    <li
      className={classes}
      data-clickable="false"
      role="menuitem"
    >
      <span data-clickable="false">{title}</span>
      <ul className="dropdown__list" role="menu">{children}</ul>
    </li>
  );
};

SubMenuItem.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Indica se invertire l'apertura del sottomenu da destra a sinistra */
  inverse: PropTypes.bool,
  /** Titolo del sottomenu. Nel caso di contenuto custom (non stringa),
     * applicare l'attributo data-clickable='false' ai componenti. */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

SubMenuItem.defaultProps = {
  children: null,
  inverse: false,
  title: '',
};

export default SubMenuItem;
